import { useHydrated } from '@tanstack/react-router';

const getCurrentDate = () => new Date();

export function useHydratedTime() {
    const hydrated = useHydrated();

    return hydrated
        ? { getHydratedNow: getCurrentDate, now: getCurrentDate() }
        : { getHydratedNow: null, now: null };
}
